import React from 'react';
import styles from "../WidgetConsignes/WidgetConsignes.module.scss";
import {Textfit} from "@aw-web-design/react-textfit";
import {useStores} from "../../../stores/Context";
import WidgetBibliothequeImagesSvg from "../../../boiteAOutils/SVG/TypeWidget/WidgetBibliothequeImagesSvg";
import {useClickBlockerToScroll} from "../../../boiteAOutils/scripts/clickBlockerToScroll";

const WidgetBibliothequeImages = () => {
    const {widgetStore, uiStore} = useStores();
    const clickHandlers = useClickBlockerToScroll
    const handleOpenBibliothequeImage = () => {
        uiStore.openConsultingBibliothequeImages();
    }



    return (
        <div className={`carte_widget ${styles.container}`}
             onClick={() => handleOpenBibliothequeImage()}
             {...clickHandlers}
        >
            <div className={`${styles.container_content}`} style={{padding: "1.5em"}}>
                <WidgetBibliothequeImagesSvg width={100} height={100} />
                <span className={`${styles.title}`} >Mes images</span>

            </div>


        </div>
    );
};

export default WidgetBibliothequeImages;